<template>
  <v-menu
    v-model="openModel"
    offset-y
    :close-on-content-click="false"
    :disabled="disabled"
    :min-width="minWidth"
    :max-width="maxWidth"
  >
    <template #activator="{ attrs, on }">
      <div v-bind="attrs" v-on="on">
        <researcher-avatar-cluster
          v-bind="attrs"
          :researchers="researchers"
          :small="false"
          :max="maxAvatarCount"
        >
          <template v-if="!disabled" #prepend>
            <review-member-management-avatar
              :empty-state="emptyState"
            />
          </template>
        </researcher-avatar-cluster>
      </div>
    </template>
    <slot name="popup"></slot>
  </v-menu>
</template>

<script>
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';
import ReviewMemberManagementAvatar from './ReviewMemberManagementAvatar';
import { ReviewMember } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ReviewMemberManagement',
  components: {
    ResearcherAvatarCluster,
    ReviewMemberManagementAvatar,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    reviewMembers: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMember),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: [String, Number],
      default: undefined,
    },
    maxWidth: {
      type: [String, Number],
      default: undefined,
    },
    maxAvatarCount: {
      type: Number,
      default: 10,
    },
  },
  emits: ['update:open'],
  computed: {
    openModel: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
    emptyState() {
      return this.reviewMembers.length === 0;
    },
    researchers() {
      return this.reviewMembers.map((member) => member.researcher);
    },
  },
};
</script>
